import { Content } from "antd/lib/layout/layout";
import { Children, ReactNode } from "react";
import Heading from "./Heading";

interface LogsProps {
    children: ReactNode;
    title?: ReactNode;
    extra?: ReactNode;
}

const Logs = ({
    title,
    extra,
    children
}: LogsProps) => {
    return (
        <Content className="content-logs">
            {
                title &&
                <div style={{ marginTop: -30 }}>
                    <Heading
                        level={5}
                        title={
                            <div className="flex-justify-space-between flex-align-center">
                                <div style={{ color: "white" }}>
                                    {title}
                                </div>
                                {extra}
                            </div>
                        }
                    />
                </div>
            }
            <code>
                {children}
            </code>
        </Content>
    )
}

export default Logs;